import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import DateAppointment from "form/components/date-appointment/date-appointment";
import SelectAppointment from "form/components/select-appointment/select-appointment";
import moment from "moment";
import {
  find,
  // forEach,
  // isEmpty,
  // isNil,
  map,
  pathOr,
  length,
  filter,
} from "ramda";
import { exists, getSections, translate } from "application/functions";

const DateInfo = (props) => {
  const {
    register,
    errors,
    locale,
    isSubmitted,
    setSelectValue,
    size,
    showDate,
    // showTime,
    // changeShowTime,
    availability,
    date,
    time,
    section,
    showByCountry,
  } = props;

  const hasToShowSection = length(getSections(availability)) > 1;

  const showFieldBySection = () =>
    (hasToShowSection && exists(section)) || !hasToShowSection;

  const getSectionsOptions = () => {
    if (!hasToShowSection) {
      return [];
    }
    return map(
      (k) => ({ key: k, label: translate(k, locale) }),
      getSections(availability)
    );
  };

  const getDays = () => {
    if (!(showDate && showFieldBySection())) {
      return [];
    }

    if (exists(section)) {
      return map(
        (filtered) => filtered.day,
        filter(
          (a) => exists(a.sectionTime) && exists(a.sectionTime[section[0]]),
          availability
        )
      );
    }

    return map((a) => a.day, availability);
  };

  const getHours = () => {
    if (!showDate || !exists(date) || !exists(availability)) {
      return [];
    }

    if (hasToShowSection && exists(section[0])) {
      const availableDate = find(
        (a) => moment(date, "DD/MM/YYYY").isSame(moment(a.day, "YYYY/MM/DD")),
        availability
      );
      return map(
        (time) => ({ key: time, label: time }),
        pathOr([], ["sectionTime", section[0]], availableDate)
      );
    }

    const availableDate = find(
      (a) => moment(date, "DD/MM/YYYY").isSame(moment(a.day, "YYYY/MM/DD")),
      availability
    );
    return map(
      (time) => ({ key: time, label: time }),
      pathOr([], ["avaialableTime"], availableDate)
    );
  };

  return (
    <Fragment>
      <SelectAppointment
        field="section"
        register={register}
        errors={errors}
        locale={locale}
        setSelectValue={(name, value) => {
          setSelectValue(name, value);
        }}
        isSubmitted={isSubmitted}
        size={size}
        required={showByCountry && showDate && hasToShowSection}
        show={showDate && hasToShowSection}
        options={getSectionsOptions()}
        value={section}
      />
      <DateAppointment
        field="day"
        register={register}
        errors={errors}
        locale={locale}
        setSelectValue={(name, value) => {
          setSelectValue(name, value);
        }}
        isSubmitted={isSubmitted}
        size={size}
        required
        showDate={showByCountry && showDate && showFieldBySection()}
        availability={getDays()}
        date={date}
      />
      <SelectAppointment
        field="time"
        register={register}
        errors={errors}
        locale={locale}
        setSelectValue={(name, value) => setSelectValue(name, value)}
        isSubmitted={isSubmitted}
        size={size}
        required
        show={date !== null}
        options={getHours()}
        value={time}
      />
    </Fragment>
  );
};

DateInfo.propTypes = {
  register: PropTypes.any,
  errors: PropTypes.any,
  locale: PropTypes.string,
  setSelectValue: PropTypes.func,
  isSubmitted: PropTypes.bool,
  showDate: PropTypes.bool,
  showTime: PropTypes.bool,
  changeShowTime: PropTypes.func,
  size: PropTypes.string,
  availability: PropTypes.array,
  date: PropTypes.any,
  section: PropTypes.any,
  time: PropTypes.any,
  showByCountry: PropTypes.bool,
};

export default DateInfo;
